import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';

// import axios from 'axios';
function _window(): any {
  // return the global native browser window object
  return window;
}

@Injectable({
  providedIn: 'root'
})
export class WorldlineService {
  baseUrl = environment.UserURL;
  AdminUrl = environment.AdminURL;
  AuthUrl = environment.AuthURL;
  constructor(private http: HttpClient, private router: Router, private toastrService: ToastrService) { }

  get nativeWindow(): any {
    return _window();
  }

  worldLineHash(post) {
    return this.http.post(`${this.AuthUrl}/api/worldLine/hashConversion`, post);
  }
  allfiles(post) {
    return this.http.post(`${this.AuthUrl}/api/storage/uploadOcrTemplates`, post);
  }
  getallfiles(post) {
    return this.http.get(`${this.AuthUrl}/api/storage/getUploadedOcrDoc?pageNumber=${post.pageNumber}&pageSize=${post.pageSize}&dateFrom=${post.startDate}&dateTo=${post.endDate}`)
  }
  deleteFile(post) {
    return this.http.delete(`${this.AuthUrl}/api/storage/deleteFile?id=${post}`)
  }
  sendInitiatePaymentLink(post) {
    return this.http.post(`${this.AuthUrl}/api/worldLine/sendInitiatePaymentLink`, post);
  }

  getWorldLineFormDatabyId(id) {
    return this.http.get(`${this.AuthUrl}/api/worldLine/getFormdataById?id=${id}`);
  }

  worldLineHashCapture(post) {
    return this.http.post(`${this.AuthUrl}/api/worldLine/hashConversionCapture`, post);
  }

  getAllPaymentList(post?) {
    if (post) {
      return this.http.get(`${this.AuthUrl}/api/worldLine/worldlineList${post}`);

    } else {
      return this.http.get(`${this.AuthUrl}/api/worldLine/worldlineList`);

    }
  }

  downloadExcel(post?) {
      return this.http.get(`${this.AuthUrl}/api/worldLine/downloadExcel${post}`);
  }

  cancelOrderapi(post) {
    return this.http.post(`${this.AuthUrl}/api/plada/cancelOrder`, post);
  }

  cancelMandate(post) {
    return this.http.post(`${this.AuthUrl}/api/mandate/cancel`, post);
  }

  getAllPaymentListbyOrganzation(post?) {
    if (post) {
      return this.http.get(`${this.AuthUrl}/api/worldLine/getListByOrgId${post}`);

    } else {
      return this.http.get(`${this.AuthUrl}/api/worldLine/getListByOrgId`);

    }

  }
  getHospitaListforWorldline() {
    return this.http.get(`${this.AuthUrl}/api/worldLine/getAllWorldlineUsersList`);
  }
  getlistDatabyHospital(post?) {
    if (post) {
      return this.http.get(`${this.AuthUrl}/api/worldLine/getListByHospitalId${post}`);

    } else {
      return this.http.get(`${this.AuthUrl}/api/worldLine/getListByHospitalId`);

    }

  }

  worldlineDashbord() {
    return this.http.get(`${this.AuthUrl}/api/worldLine/dashboardData`)
  }
  dashboardDataHospital() {
    return this.http.get(`${this.AuthUrl}/api/worldLine/dashboardDataHospital`)
  }

  // Plada Payment API's

  pladaAddData(post) {
    // debugger
    return this.http.post(`${this.AuthUrl}/api/plada/pladaAuth`, post);
  }

  pladaCapture(post) {
    return this.http.post(`${this.AuthUrl}/api/plada/excecuteMandate`, post);
  }
  redirectit(post) {
    return this.http.post(`${this.AuthUrl}/api/plada/returnDataApi`, post);
  }
  redirectApi(post) {
    return this.http.post(`${this.AuthUrl}/api/plada/redirectApi`, post);
  }
  showToaster(message) {
    this.toastrService.success(message);
  }

  ErrorSuccess(message) {
    this.toastrService.error(message);
  }

  infoSuccess(message) {
    this.toastrService.info(message);
  }

  warningSuccess(message) {
    this.toastrService.warning(message);
  }
  OtypeTransaction(id, shouldAddHours?) {
    console.log("shouldAddHours", shouldAddHours);
    return this.http.post(`${this.AuthUrl}/api/worldLine/OtypeTransaction?id=${id}`, { shouldAddHours });
  }
  // worldLineSendOtp(post){
  //   return this.http.post(`${this.AuthUrl}/api/worldLine/send-otp`,post);
  // }
  // worldLineVerifyOtp(post){
  //   return this.http.post(`${this.AuthUrl}/api/worldLine/verify-otp`,post);
  // }
  worldLineSendOtp(post) {
    return this.http.post(`${this.AuthUrl}/api/worldLine/send-otp`, post);
  }
  worldLineVerifyOtp(post) {
    return this.http.post(`${this.AuthUrl}/api/worldLine/verify-otp`, post);
  }
  worldlineSenddemail(post) {
    return this.http.post(`${this.AuthUrl}/api/worldLine/sendemailforManipal`, post)
  }
  updatedataformanipal(post) {
    return this.http.post(`${this.AuthUrl}/api/worldLine/updatedataformanipal`, post)
  }
  findById(post) {
    return this.http.post(`${this.AuthUrl}/api/worldLine/findById`, post);
  }
  internalLogin(post) {
    return this.http.post(`${this.AuthUrl}/api/worldLine/internalLogin`, post)
  }
  sendemailformanipalConfirm(post) {
    return this.http.post(`${this.AuthUrl}/api/worldLine/sendemailformanipalConfirm`, post);
  }
  internalLoginemail(post) {
    return this.http.post(`${this.AuthUrl}/api/worldLine/internalLoginemail`, post)
  }

  // Final Submit Count 
  // getSubmitCount(post) {
  //   return this.http.post(`${this.AuthUrl}/api/worldLine/getSubmitCount`, post)
  // }
  private myMethod = new Subject();
  myMethodInvoke = this.myMethod.asObservable();
  changeResponse(boolean) {
    this.myMethod.next(boolean);
  }
}